import api from './client';

function drfNextToApiRelativePath(nextUrl) {
  try {
    const u = new URL(
      nextUrl,
      typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
    );
    const p = u.pathname || '';
    const marker = '/api';
    const idx = p.indexOf(marker);
    const rest = idx >= 0 ? p.slice(idx + marker.length) : p;
    const rel = (rest.startsWith('/') ? rest : `/${rest}`) + (u.search || '');
    return rel || null;
  } catch {
    return null;
  }
}

/**
 * Загружает одну страницу из DRF пагинации.
 * Возвращает results, nextPath (relative /api path), count (если есть).
 */
export default async function fetchTaskListPage(path, { pageSize } = {}) {
  const basePath = path && path.startsWith('/') ? path : '/tasks/';
  const url = new URL(basePath, 'http://local');
  if (pageSize != null && String(pageSize).trim() !== '') {
    url.searchParams.set('page_size', String(pageSize));
  }
  const relPath = url.pathname + (url.search || '');

  const res = await api.get(relPath);
  const body = res.data;

  if (Array.isArray(body)) {
    return { results: body, nextPath: null, count: body.length };
  }

  const results = Array.isArray(body?.results) ? body.results : [];
  const nextPath = body?.next ? drfNextToApiRelativePath(body.next) : null;
  const count = typeof body?.count === 'number' ? body.count : null;

  return { results, nextPath, count };
}

